export default "__VITE_PUBLIC_ASSET__95367790__"